import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SEGMENTS } from 'app/core/constants/faqs';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
  ]
})
export class PopupComponent {

  page: any = '';
  type: any = '';
  data: any = {};
  urlSafeDesktop: SafeResourceUrl | undefined;
  urlSafeMobile: SafeResourceUrl | undefined;
  registerUrl: string = '';
  popupGA: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public items: any,
    public dialogRef: MatDialogRef<PopupComponent>,
    private readonly domSanitizer: DomSanitizer
  ) {
    let autoplay = '?autoplay=1&mute=1';
    this.page = items?.from;
    this.type = items?.type;
    this.data = items?.data ? items?.data : items;
    if(window.innerWidth >= 	1024) {
      this.urlSafeDesktop = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data?.video + autoplay);
      this.urlSafeMobile = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data?.video);
    } else {
      this.urlSafeDesktop = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data?.video);
      this.urlSafeMobile = this.domSanitizer.bypassSecurityTrustResourceUrl(this.data?.video + autoplay);
    }
    this.registerUrl = this.data?.registerUrl;
    this.popupGA = this.data.POPUP_GA;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onSelectProduct() {
    let location = this.data?.url;
    window.open(location, '_blank');
  }

  register() {
    window.open(this.registerUrl, "_blank");
  }

  goToFAQ(jenis: any) {
    let x = jenis.split('.')[1];
    let url = `/faq?segment=${SEGMENTS.CGC}`;
    if(x == 'FINANCIAL_ADVISORY') {
      url += '&item=4';
    } else if (x == 'ADVISORY_WORKSHOPS') {
      url += '&item=2';
    } else if (x == 'ACCESS_NEW_MARKETS') {
      url += '&item=1';
    } else {
      url += '&item=3';
    }
    window.open(url, "_self");
  }
}
